<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><b><i>Contents</i></b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/06_List_of_Tables">List of Tables</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/07_List_of_Maps">List of Maps</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/08_List_of_Plates">List of Plates</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/10_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/11_Introduction">Introduction</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/12_Notes_on_Sources">Notes on Sources</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/13_Prologue"><i>Prologue</i></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/13_Prologue"><b>Yorktown 1781</b></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/14_Part01"><b><span class="small">PART I</span></b></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/14_Part01"><b>Lock, Stock and Barrel</b></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><a href="#/xhtml/14_Part01#sec_1">Development of Siege and Fortress Artillery</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/15_Chapter01"><i>Chapter 1</i></a></p></td>
<td align="left" valign="top"><p class="toc2"><a href="#/xhtml/15_Chapter01">To Serve the Piece</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><a href="#/xhtml/15_Chapter01#sec_1">The Intricacies of Artillery Employment</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter02" title="Link target outside of Sample"><i>Chapter 2</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/16_Chapter02" title="Link target outside of Sample">Fortress and Siege Fortifications</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/16_Chapter02#sec_1" title="Link target outside of Sample">And the Attack and Defence of Places</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter03" title="Link target outside of Sample"><i>Chapter 3</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/17_Chapter03" title="Link target outside of Sample">Tunnel and Spade Men</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/17_Chapter03#sec_1" title="Link target outside of Sample">The Engineer Arm</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Chapter04" title="Link target outside of Sample"><i>Chapter 4</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/18_Chapter04" title="Link target outside of Sample">To Reap the Whirlwind</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/18_Chapter04#sec_1" title="Link target outside of Sample">The Congreve Rocket</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Chapter05" title="Link target outside of Sample"><i>Chapter 5</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/19_Chapter05" title="Link target outside of Sample">Wooden Walls and Iron Guns</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/19_Chapter05#sec_1" title="Link target outside of Sample">Naval Artillery</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Chapter06" title="Link target outside of Sample"><i>Chapter 6</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/20_Chapter06" title="Link target outside of Sample">Hephaestus’ Gifts</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/20_Chapter06#sec_1" title="Link target outside of Sample">Artillery Uniforms</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_Part02" title="Link target outside of Sample"><b><span class="small">PART II</span></b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/21_Part02" title="Link target outside of Sample"><b>Parallels</b></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_Chapter07" title="Link target outside of Sample"><i>Chapter 7</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/22_Chapter07" title="Link target outside of Sample">The Second Siege of Saragossa</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Chapter08" title="Link target outside of Sample"><i>Chapter 8</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/23_Chapter08" title="Link target outside of Sample">Castles in Spain</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/23_Chapter08#sec_1" title="Link target outside of Sample">The British Sieges of Ciudad Rodrigo, Badajoz, and San Sebastian</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Chapter09" title="Link target outside of Sample"><i>Chapter 9</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/24_Chapter09" title="Link target outside of Sample">Sieges East and West</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/24_Chapter09#sec_1" title="Link target outside of Sample">Danzig and Hamburg</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/25_Chapter10" title="Link target outside of Sample"><i>Chapter 10</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/25_Chapter10" title="Link target outside of Sample">The Siege of Fort Erie</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/26_Part03" title="Link target outside of Sample"><b><span class="small">PART III</span></b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/26_Part03" title="Link target outside of Sample"><b>Artillery Afloat</b></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/27_Chapter11" title="Link target outside of Sample"><i>Chapter 11</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/27_Chapter11" title="Link target outside of Sample">Tall Frigates that Walk the Sea</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/27_Chapter11#sec_1" title="Link target outside of Sample">USS <i>Constitution</i> vs HMS <i>Guerriere</i></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/28_Chapter12" title="Link target outside of Sample"><i>Chapter 12</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/28_Chapter12" title="Link target outside of Sample">‘We Have Met the Enemy’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/28_Chapter12#sec_1" title="Link target outside of Sample">Fleet Action on Lake Erie</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/29_Epilogue" title="Link target outside of Sample"><b>Epilogue</b></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/29_Epilogue" title="Link target outside of Sample"><b>‘Bombs Bursting in Air’</b></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/29_Epilogue#sec_1" title="Link target outside of Sample">The British Naval Attack on Baltimore, 1814</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/30_Appendices#Appendices" title="Link target outside of Sample"><b>Appendices</b></span></p></td>
<td align="left" valign="top"><p class="toc2"> </p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/30_Appendices" title="Link target outside of Sample">Introduction</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/31_Appendix_I" title="Link target outside of Sample"><i>Appendix I</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/31_Appendix_I" title="Link target outside of Sample">‘That Devil Gribeauval’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/32_Appendix_II" title="Link target outside of Sample"><i>Appendix II</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/32_Appendix_II" title="Link target outside of Sample">Spiking of Cannon</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/33_Appendix_III" title="Link target outside of Sample"><i>Appendix III</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/33_Appendix_III" title="Link target outside of Sample">Batteries</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/34_Appendix_IV" title="Link target outside of Sample"><i>Appendix IV</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/34_Appendix_IV" title="Link target outside of Sample">Pick and Shovel</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/35_Appendix_V" title="Link target outside of Sample"><i>Appendix V</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/35_Appendix_V" title="Link target outside of Sample">Heavy Artillery</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/36_Appendix_VI" title="Link target outside of Sample"><i>Appendix VI</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/36_Appendix_VI" title="Link target outside of Sample">By Land and By Sea</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/37_Appendix_VII" title="Link target outside of Sample"><i>Appendix VII</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/37_Appendix_VII" title="Link target outside of Sample">‘Fire on the Up Roll’</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc3"> </p></td>
<td align="left" valign="top"><p class="toc3a"><span href="#/xhtml/37_Appendix_VII#sec_1" title="Link target outside of Sample">Naval Ordnance and Gunnery</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/38_Appendix_VIII" title="Link target outside of Sample"><i>Appendix VIII</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/38_Appendix_VIII" title="Link target outside of Sample">Casting and Proving Cannon</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/39_Appendix_IX" title="Link target outside of Sample"><i>Appendix IX</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/39_Appendix_IX" title="Link target outside of Sample">Fortification</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/40_Appendix_X" title="Link target outside of Sample"><i>Appendix X</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/40_Appendix_X" title="Link target outside of Sample">Artillery Cartridges</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/41_Appendix_XI" title="Link target outside of Sample"><i>Appendix XI</i></span></p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/41_Appendix_XI" title="Link target outside of Sample">Mines and Countermines</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/42_Glossary" title="Link target outside of Sample">Glossary</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc1"> </p></td>
<td align="left" valign="top"><p class="toc2"><span href="#/xhtml/43_Bibliography" title="Link target outside of Sample">Bibliography</span></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?4258cebc